// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-application p[data-v-d7d7d80a]{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
